import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ArrowDown, Users } from 'lucide-react';

const TeamsHero = ({ onStartTrial, onLearnMore }) => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Gradient orbs */}
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Badge */}
        <Badge 
          variant="outline" 
          className="mb-8 px-4 py-2 border-blue-500/30 bg-blue-500/10 text-blue-300"
          data-testid="teams-badge"
        >
          <Users className="w-4 h-4 mr-2" />
          For Team Leaders & Managers
        </Badge>

        {/* Main headline */}
        <h1 
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
          data-testid="teams-headline"
        >
          What's really happening
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
            in your team?
          </span>
        </h1>

        {/* Value props */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <p className="text-lg sm:text-xl text-slate-300">
            Performance reviews without guesswork.
          </p>
          <span className="hidden sm:block text-slate-500">|</span>
          <p className="text-lg sm:text-xl text-slate-300">
            Team health without surveillance.
          </p>
        </div>

        {/* Subheadline */}
        <p 
          className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed"
          data-testid="teams-subheadline"
        >
          Your team members reflect on their work. You get anonymized signals about where 
          they need support — and evidence for reviews that writes itself.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Button 
            size="lg"
            onClick={onStartTrial}
            className="w-full sm:w-auto px-8 py-6 text-lg bg-blue-600 hover:bg-blue-500 text-white"
            data-testid="teams-start-trial-btn"
          >
            Start Team Trial — 28 Days Free
          </Button>
          <Button 
            variant="ghost"
            size="lg"
            onClick={onLearnMore}
            className="w-full sm:w-auto px-8 py-6 text-lg text-slate-300 hover:text-white hover:bg-slate-800/50"
            data-testid="teams-learn-more-btn"
          >
            See How It Works
            <ArrowDown className="w-5 h-5 ml-2" />
          </Button>
        </div>

        {/* Trust line */}
        <p className="text-sm text-slate-500">
          No credit card required. Invite 3+ team members to start.
        </p>
      </div>
    </section>
  );
};

export default TeamsHero;
